import { chain } from 'lodash';

/**
 * Location Search Lookup
 *
 * Retrieve location query search value by key
 *
 * @example
 *  window.location.search
 *  //-> '?name=bobross&job=painter'
 *  locationSearchLookup(window.location.search, 'job')
 *  //-> 'painter'
 *  locationSearchLookup(window.location.search, 'address')
 *  //-> undefined
 * @inspiredby http://www.timetler.com/2013/11/14/location-search-split-one-liner/
 * @param search
 * @param key
 * @returns {string|undefined}
 */
export function locationSearchLookup(search: string, key) {
  // Remove the '?' at the start of the string and split out each assignment
  const params = chain(search.slice(1).split('&'))
    // Split each array item into [key, value]
    // ignore empty string if search is empty
    .map(function (item) {
      if (item) {
        return item.split('=');
      }
    })
    // Remove undefined in the case the search is empty
    .compact()
    // Turn [key, value] arrays into object parameters
    .fromPairs()
    // Return the value of the chain operation
    .value();

  return params[key] as string;
}
